<template>
  <modal class="modalCG topModal" @before-open="iphoneModalsSet" @before-close="closingModal" name="modalResetPassword" height="auto" :adaptive="true" :scrollable="true">
    <div class="modal-box">
      <div class="modal-header">
        <h2>Passwort zurücksetzen</h2>
        <span class="close" @click.prevent="toggleModal">
          <icon name="close" scale="2"></icon>
        </span>
      </div>
      <div class="modal-body text-center">
        <form>
        <div class="form-field sized">
          <label for="reset_pas_email">Email</label>
          <input
            type="text"
            id="reset_pas_email"
            placeholder="Email"
            v-model="email"
            name="email"
            v-validate="'required|email'"
            :class="{'error': errors.has('email') }"
            data-vv-as="Email"
            @keyup.enter="resetPas"
          >
          <span v-show="errors.has('email')" class="errorMsg">{{ errors.first('email') }}</span>
          <span v-show="bag.has('email:duplicate')" class="errorMsg">{{ bag.first('email:duplicate') }}</span>
        </div>
        </form>
        <div>
          <span><a @click.prevent="toggleLogin">Zurück zur Anmeldung</a></span>
        </div>
      </div>
      <div class="modal-action">
        <button class="btn green" @click.prevent="resetPas">Neues Passwort anfordern</button>
      </div>
    </div>
  </modal>
</template>

<script>
  import { EventBus } from '@/assets/js/event-bus.js'
  import { mapActions } from 'vuex'
  import { ErrorBag } from 'vee-validate'
  import helpers from '@/mixins/helpers.js'
  import formatting from '@/mixins/formatting.js'

  export default {
    name: 'PasswordResetModal',
    mounted () {
      EventBus.$on('togglePasswordResetModal', () => {
        this.toggleModal()
      })
      EventBus.$on('escKey', () => {
        this.clearModal()
        this.showPasswordReset = false
        this.$modal.hide('modalResetPassword')
      })
    },
    beforeDestroy () {
      EventBus.$off('togglePasswordResetModal')
      EventBus.$off('escKey')
    },
    data () {
      return {
        bag: new ErrorBag(),
        showPasswordReset: false,
        email: '',
        saveToast: null
      }
    },
    mixins: [helpers, formatting],
    methods: {
      ...mapActions([
        'sendPasswordLink'
      ]),
      closingModal () {
        this.showPasswordReset = false
        this.iphoneModalsUnset()
      },
      closeModal (e) {
        if (e.target.className === this.$refs.modalbackround.className) {
          this.toggleModal()
        }
      },
      toggleModal () {
        var vm = this
        vm.showPasswordReset = !vm.showPasswordReset
        vm.clearModal()
        this.showPasswordReset ? this.$modal.show('modalResetPassword') : this.$modal.hide('modalResetPassword')
      },
      clearModal () {
        var vm = this
        vm.errors.clear()
        vm.email = ''
        if (vm.showPasswordReset) {
          document.body.classList.add('scrollbar')
          document.getElementById('app').classList.add('overflow-hidden')
        } else {
          document.body.classList.remove('scrollbar')
          document.getElementById('app').classList.remove('overflow-hidden')
        }
      },
      toggleLogin () {
        this.toggleModal()
        EventBus.$emit('toggleLoginModal')
      },
      resetPas () {
        var vm = this
        vm.$validator.validateAll().then((result) => {
          if (result) {
            if (!vm.saveToast) {
              vm.saveToast = vm.$toasted.info('Wird gespeichert...', {
                theme: 'primary',
                position: 'top-right',
                duration: 10000,
                icon: 'info'
              })
              vm.sendPasswordLink({
                email: vm.email,
                cb: (response) => {
                  vm.saveToast.goAway(100)
                  vm.saveToast = null
                  vm.toggleModal()
                  vm.$toasted.success('Wir haben Dir eine Email zum Zurücksetzen des Passworts geschickt.', {
                    theme: 'primary',
                    position: 'top-right',
                    duration: 10000,
                    action: {
                      text: 'X',
                      class: 'toastBtn',
                      onClick: (e, toastObject) => {
                        toastObject.goAway(0)
                      }
                    },
                    icon: 'email'
                  })
                },
                errorCb: (error) => {
                  vm.saveToast.goAway(100)
                  vm.saveToast = null
                  vm.toggleModal()
                  if (error.response && error.response.status === 404) {
                    vm.$toasted.success('Wir haben Dir eine Email zum Zurücksetzen des Passworts geschickt.', {
                      theme: 'primary',
                      position: 'top-right',
                      duration: 10000,
                      action: {
                        text: 'X',
                        class: 'toastBtn',
                        onClick: (e, toastObject) => {
                          toastObject.goAway(0)
                        }
                      },
                      icon: 'email'
                    })
                  } else {
                    vm.$toasted.error('Ups, das hat nicht geklappt - bitte versuche es später nochmal!', {
                      theme: 'primary',
                      position: 'top-right',
                      duration: 10000,
                      action: {
                        text: 'X',
                        class: 'toastBtn',
                        onClick: (e, toastObject) => {
                          toastObject.goAway(0)
                        }
                      },
                      icon: 'close'
                    })
                  }
                }
              })
            }
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/modals/PasswordReset.vue